<template>
  <div class="monitor-state-icon" @click="handleClick">
    <div class="circular" :style="{ backgroundColor: color }" :class="alarmAnimateClass"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getOptions } from '@/utils/deviceUtils/state';

export default {
  props: {
    state: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('mqtt', ['alarmSnMap']),
    stateKey() {
      return this.dict[this.state];
    },
    isActive() {
      const { runstate, state2 } = this.value;

      const opt = getOptions(runstate, state2);

      if (this.state === 2) {
        return ['报警', '预警'].includes(opt.t);
      } else if (this.state === 1) {
        return opt.t === '故障';
      } else if (this.state === 0) {
        return !['离线', '故障', '报警', '预警'].includes(opt.t);
      }

      return false;
    },
    color() {
      const target = this.isActive ? this.colors : this.dimColors;
      return target[this.stateKey];
    },
    isAlarmActive() {
      return this.stateKey === 'alarm' && this.isActive;
    },
    alarmAnimateClass() {
      if (!this.isActive) return;
      return 'animate';
    }
  },
  data() {
    return {
      dict: {
        0: 'success',
        1: 'fault',
        2: 'alarm'
      },
      colors: {
        success: 'var(--cotton-state-icon-active-success)',
        fault: 'var(--cotton-state-icon-active-fault)',
        alarm: 'var(--cotton-state-icon-active-alarm)'
      },
      dimColors: {
        success: 'var(--cotton-state-icon-dim-success)',
        fault: 'var(--cotton-state-icon-dim-fault)',
        alarm: 'var(--cotton-state-icon-dim-alarm)'
      }
    };
  },
  methods: {
    handleClick() {
      if (this.isAlarmActive) this.$emit('disposition');
    }
  }
};
</script>

<style lang="scss">
.monitor-state-icon {
  width: calc(var(--font-size) * 1.3 + 20px);
  height: calc(var(--font-size) * 1.3 + 20px);
  border-radius: 50%;

  display: inline-block;

  cursor: pointer;

  background: var(--cotton-state-icon-outer-bg);
  box-shadow: 0 0 5px 1px var(--cotton-state-icon-shadow);

  .circular {
    width: 80%;
    height: 80%;
    border-radius: 50%;
    position: relative;
    left: 10%;
    top: 10%;
  }

  .animate {
    animation: breathing 0.4s ease infinite alternate;
  }

  @keyframes breathing {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
}
</style>
